export const MATERIAL_COLOR = "#d5d5d5";
